import React from 'react';

const DriverList = React.lazy(() => import('./DriversPage'));
const NewDriver = React.lazy(() => import('./driver-detail/Driver'));
const NewVehicle = React.lazy(() => import('./new-vehicle/NewVehicle'));
const DetailDriver = React.lazy(() => import('./detail-driver/DetailDriver'));
const DriversConfig = {
  settings: {
    layout: {
      config: {},
    },
  },

  routes: [
    {
      path: 'drivers/list',
      element: <DriverList />,
      auth: null,
    },
    {
      path: 'drivers/edit-driver/:id',
      element: <NewDriver />,
      auth: null,
    },
    {
      path: 'drivers/detail-driver/:id',
      element: <DetailDriver />,
      auth: null,
    },
    {
      path: 'drivers/new-vehicle',
      element: <NewVehicle />,
      auth: null,
    },
  ],
};

export default DriversConfig;
